module.exports = __webpack_public_path__ + "static/thpcblueelephmain-997a67f770e45e82feb7221d57d21395.jpeg";